export const ACCESS_TOKEN = 'a_t';
export const APP_INSTANCE_ID = 'a_i';
export const COMPATIBLE_PAGE = 'c_p';
export const DEVICE_CODENTIFY_FACTORY = 'd_c_f';
export const DEVICE_DATA = 'd_d';
export const GAM_GIGYA_ACCOUNT_DATA = '__coresiteAccount';
export const LANGUAGE_CODE = 'l_c';
export const MARKET_CODE = 'm_c';
export const REFRESH_TOKEN = 'r_t';
export const SPICE_TOKEN = 's_t';
export const USER_NAME = 'u_n';
export const TRY_FEATURE_FIRST_SHOW = 't_f_f_s';
export const AGE_GATE_LOCKED_TS = 'a_g_l_t';
export const AGE_GATE_TS = 'a_g_t';
export const RECAPTCHA_TOKEN = 'r_c_t';
export const GEO_RESTRICTION = 'g_r';
